// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__iP58w","question":"style_question__Z3gyj","paragraph":"style_paragraph__6uCUD","button":"style_button__9fKDr","imgBack":"style_imgBack__KEbZf"};